<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Config'|translate }}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Config')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <config-record-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()"></config-record-dialog>
                </v-card-actions>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="config"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                        :search="search2"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.config_id }}</td>
                            <td class="text-xs-left">
                                {{ props.item.config_name }}
                            </td>
                            <td class="text-xs-left">{{ props.item.facility_name }}</td>
                            <td class="text-xs-left">
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'Config')"
                                    @click="$can('update', 'Config') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'Config')"
                                    @click="$can('update', 'Config') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                    <p v-if="frontendVersion" class="mt-2">
                        Version : {{ frontendVersion }}
                    </p>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getConfig, deleteConfig} from '../helper'
import ConfigRecordDialog from '../components/config/ConfigRecordDialog'

export default {
    name: 'Config',
    components: {ConfigRecordDialog},
    data() {
        return {
            dialog: false,
            headers: [
                {
                    text: this.$options.filters.translate('Config ID'),
                    align: 'left',
                    sortable: true,
                    value: 'config_id',
                },
                {text: this.$options.filters.translate('Config Name'), value: 'config_name'},
                {text: this.$options.filters.translate('Facility Name'), value: 'facility_name'},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
            config: [],
            editedItem: {},
            search: '',
            search2: ''
        }
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    mounted() {
        this.initialize()
    },
    computed: {
        frontendVersion() {
            return process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : null
        }
    },
    methods: {
        initialize() {
            this.refresh()
        },
        editItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.dialog = true
        },
        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteConfig({
                    'config_id': item.config_id
                })
                this.refresh()
            }
        },
        async refresh() {
            let df = await getConfig({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            this.config = df['result']
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
    }
}
</script>

<style scoped>

</style>
